module.exports = {
    bankTransactionService: 'bank_transaction_service'
}
